import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { Header } from './Header';
import { HeaderStrapiProps, transformStrapiHeader } from './transformer';

export type { HeaderStrapiProps };

export function HeaderStrapi({
  block,
}: BlockComponentModel<HeaderStrapiProps>) {
  return <Header {...transformStrapiHeader(block)} />;
}
